import { render, staticRenderFns } from "./PregledKretanjaVozila.vue?vue&type=template&id=6d907150&scoped=true&"
import script from "./PregledKretanjaVozila.vue?vue&type=script&lang=ts&"
export * from "./PregledKretanjaVozila.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d907150",
  null
  
)

export default component.exports